exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-details {\r\n  border:2px solid #941246;\r\n  padding:20px;\r\n  margin-top:50px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/subscription-details/subscription-details.component.css
// module id = ../../../../../src/app/subscription-details/subscription-details.component.css
// module chunks = 2